import { render, staticRenderFns } from "./ion-input.vue?vue&type=template&id=80e3c326"
import script from "./ion-input.vue?vue&type=script&lang=js"
export * from "./ion-input.vue?vue&type=script&lang=js"
import style0 from "./ion-input.vue?vue&type=style&index=0&id=80e3c326&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports